import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-delete-tree-level-dialog',
    template: `
    <h4 class="pb-4">Are you sure that you want to delete @if (this.config.data.level !== 'companies') {
      <span>{{ parentName }}?</span>
    } {{ levelName }}?</h4>

    <p-checkbox style="border: 1px solid red" class="pb-1" (keydown.enter)="onConfirm()" [(ngModel)]="accept" [binary]="true"
      inputId="accept"></p-checkbox>

    <span class="pl-2" for="accept"> I understand that <b> {{ levelName }} </b> and any item(s) contained within will be deleted and
      that this action is <b>PERMANENT</b> and <b>CANNOT BE UNDONE!</b></span>

    <div class="float-right pt-9">
      <button title="Please confirm by checking the checkbox" pButton type="button" [disabled]="!accept" label="Confirm" icon="pi pi-check" (click)="onConfirm()"
        class="p-button-text p-button-success"></button>
      <button pButton type="button" class="p-button-text p-button-danger" label="Cancel" (click)="onCancel()"
        icon="pi pi-times"></button>
    </div>
    `,
    standalone: false
})
export class DeleteTreeLevelDialogComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.level = this.config.data.level;
    this.levelName = this.config.data.levelName;
    this.parentName = this.config.data.parentName;
  }

  public accept: boolean;
  public level: string;
  public levelName: string;
  public parentName: string;

  onConfirm(): void {
    this.ref.close('confirmed');
  }

  onCancel(): void {
    this.ref.close();
  }
}
